"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWorkspacesList = exports.usePreferences = exports.PreferencesProvider = exports.PreferencesContext = void 0;
const react_1 = require("react");
const preferencesReducer_1 = require("../reducer/preferences/preferencesReducer");
const isReadOnlyWorkspace_1 = require("../reducer/preferences/utilities/isReadOnlyWorkspace");
exports.PreferencesContext = (0, react_1.createContext)(preferencesReducer_1.preferencesInitialState);
exports.PreferencesProvider = exports.PreferencesContext.Provider;
function usePreferences() {
    const context = (0, react_1.useContext)(exports.PreferencesContext);
    if (!context) {
        throw new Error('Preferences context was not found');
    }
    const { workspace, workspaces } = context;
    return (0, react_1.useMemo)(() => {
        return {
            ...context,
            current: workspaces?.[workspace.current] || workspaces.default,
            isCurrentWorkspaceReadOnly: (0, isReadOnlyWorkspace_1.isReadOnlyWorkspace)(context),
        };
    }, [workspaces, workspace, context]);
}
exports.usePreferences = usePreferences;
function useWorkspacesList() {
    const { workspaces } = usePreferences();
    return (0, react_1.useMemo)(() => {
        return Object.keys(workspaces).map((key) => {
            const { visible, source } = workspaces[key];
            return {
                key,
                ...workspaces[key],
                visible: !(source === 'predefined' && !visible),
            };
        });
    }, [workspaces]);
}
exports.useWorkspacesList = useWorkspacesList;
